import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-roundabout-left', 'ArrowRoundaboutLeft', [["path",{"d":"M3 9h8a5 5 0 1 1 5 5v7"}],["path",{"d":"M7 5l-4 4l4 4"}]]);